import { useCallback } from 'react';
import { useHistory as useReactRouterHistory } from 'react-router-dom';
import { LocationDescriptor } from 'history';
import { getInitialMountingPath } from 'utils/app/get-initial-mounting-path';

const STATE_FROM: string[] = [];

export const useHistory = () => {
  const history = useReactRouterHistory();

  const push = useCallback((location: LocationDescriptor) => {
    STATE_FROM.push(`${window.location.pathname}${window.location.search}`);
    history.push(location);
  }, []);

  const getFrom = useCallback(() => {
    const initialMountingPath = getInitialMountingPath();
    return STATE_FROM.pop() || initialMountingPath;
  }, []);

  const goBack = useCallback(() => {
    const fromUrl = getFrom();
    history.push(fromUrl);
  }, []);

  return { history, push, getFrom, goBack, location: history.location };
};
